import _isEmpty from 'lodash/isEmpty';
import _isBoolean from 'lodash/isBoolean';

export const validateName = value => {
  if (!value) return 'Title is required';
  return '';
};

export const validateServiceDays = value => {
  if (!value) return 'Return window duration is required';
  if (+value < 0 || !Number.isInteger(+value)) return 'Enter a valid duration';
  return '';
};

export const validateStartsFrom = value => {
  if (!_isBoolean(value)) {
    return 'Return window start criteria needs to be specified';
  }
  return '';
};

export const validateProductVariants = list => {
  if (_isEmpty(list)) {
    return 'Adding SKUs is required to create return window exception';
  }
  return '';
};

export const validateProductTypes = list => {
  if (_isEmpty(list)) {
    return 'Adding product types is required to create return window exception ';
  }
  return '';
};

export const validateProductCategories = list => {
  if (_isEmpty(list)) {
    return 'Adding product categories is required to create return window exception ';
  }
  return '';
};
